import Joi from '@hapi/joi';

export const NetOutturnAddEditSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group required`,
    }),
    estateID: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Estate required`,
    }),
    Outturn: Joi.number()
        .positive()
        .precision(2)
        .required()
        .label("Net Outturn")
        .messages({
        "number.base": `Net Outturn must be a number`,
        "number.positive": `Net Outturn must be a positive number`,
        "any.required": `Net Outturn is required`,
        "number.precision": `Net Outturn must have exactly 2 decimal places`,
    }),
};

export const NetOutturnListingSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group required`,
    }),
    estateID: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Estate required`,
    }),
    year: Joi.string().allow("").label("Year"),
    month: Joi.string().allow("").label("Month"),
    searchMonth: Joi.string().allow("").label("Search Month"),
};